import { render, staticRenderFns } from "./PromocodesPage.vue?vue&type=template&id=c0e8d404&scoped=true"
import script from "./PromocodesPage.vue?vue&type=script&lang=js"
export * from "./PromocodesPage.vue?vue&type=script&lang=js"
import style0 from "./PromocodesPage.vue?vue&type=style&index=0&id=c0e8d404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e8d404",
  null
  
)

export default component.exports